import locale from './locale'
import reporter from './reporter'

export default {
  serverUrl: 'https://tunejaiproject.herokuapp.com/',
  facebookUrl: 'https://graph.facebook.com/',
  appid: '191472260486447',

  theme: {
    logo: '/static/img/logo_white.png',
    small_logo: '/static/img/logo-small.png',
    short_small_logo: '/static/img/logo-small-mobile.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#61a9de',
    brand_color: '#61a9de', // #ed1839
    secondary_color: '#ff687f' // #ff687f
  },

  fb_scope:
    'pages_messaging,page_events,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_posts,pages_manage_engagement,public_profile',

  reporter: reporter,
  locale: locale.locale
}



// WEBPACK FOOTER //
// ./src/app-config/index.js